import React from 'react';
import styles from "@/app/page.module.css";

const VIDEO_SRC = "/assets/videos/ent-central-final-nov-22-1_eRqVOqAl.mp4";

export default function VideoNewsletter() {
  return (
    <section className={styles.videoNewsletterSection}>
      <div className={styles.videoContainer}>
        <video
          className={styles.videoBackground}
          autoPlay
          loop
          playsInline
          controlsList="nodownload"
          muted
        >
          <source src={VIDEO_SRC} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className={styles.videoOverlay}>
          <div className={styles.videoHeadingBox}>
            <h2 className={styles.videoHeading}>
              Precision Care With Global Expertise
            </h2>
          </div>
        </div>
      </div>

      <div className={styles.newsletterForm}>
        <form className={styles.newsletterFormInner}>
          <input
            type="email"
            placeholder="Your Email"
            className={styles.newsletterInput}
            required
          />
          <button type="submit" className={styles.newsletterButton}>
            Subscribe
          </button>
        </form>
      </div>
    </section>
  );
}
